export const buttonFocusRingClasses =
  'outline-none focus-visible:border-focus-ring focus-visible:ring-focus-ring focus-visible:ring-2';
